export default "__VITE_ASSET__DT02K2aa__"